import { Card, CardHeader, CardContent } from '@ahafood/ui/components/card';
import { Separator } from '@ahafood/ui/components/separator';
import { Skeleton } from '@ahafood/ui/components/skeleton';

export function MenuItemsSkeleton() {
  return (
    <>
      {[...Array(3)].map((_, categoryIndex) => (
        <Card
          className="overflow-hidden relative border-none rounded-none shadow-none"
          key={categoryIndex}
        >
          <CardHeader className="p-4 w-full">
            <Skeleton className="h-6 w-3/4" />
          </CardHeader>
          <Separator className="mx-4 w-[calc(100%-2rem)]" />
          <CardContent className="grid grid-cols-2 gap-4 p-4">
            {[...Array(4)].map((_, itemIndex) => (
              <div
                key={itemIndex}
                className="flex flex-col rounded-md overflow-hidden hover:shadow-sm"
              >
                <Skeleton className="aspect-square w-full" />
                <div className="p-3 space-y-2">
                  <Skeleton className="h-5 w-3/4" />
                  <Skeleton className="h-5 w-1/2" />
                </div>
              </div>
            ))}
          </CardContent>
        </Card>
      ))}
    </>
  );
}
